import { ActionMenu } from "@/components/ActionMenu.tsx";
import { WButton, type WButtonProps } from "@/components/button/WButton.tsx";
import { MaskIcon } from "@/components/icon/MaskIcon.tsx";
import { availableLanguagesAtom, languageAtom, languageStoreAtom } from "@/modules/l10n/i18n.store.ts";
import { allLanguageItems } from "@/modules/l10n/languages.ts";
import { useLingui } from "@lingui/react/macro";
import { atom } from "jotai";
import { useAtomValue, useSetAtom } from "jotai/react";
import type { ReactNode } from "react";

const availableLanguageItemsAtom = atom((get) => {
    const available = get(availableLanguagesAtom);
    return allLanguageItems.filter((l) => available.includes(l.id));
});

function LocaleMenu({ children }: { children: ReactNode }) {
    const { t } = useLingui();
    const language = useAtomValue(languageAtom);
    const setLanguage = useSetAtom(languageStoreAtom);
    const items = useAtomValue(availableLanguageItemsAtom);

    return (
        <ActionMenu header={t`Language`} items={items} onAction={({ id }) => setLanguage(id)} selectedKeys={[language]}>
            {children}
        </ActionMenu>
    );
}

interface LocaleButtonProps extends Omit<WButtonProps, "action"> {
    showTitle?: boolean;
}

function LocaleButton(props: LocaleButtonProps) {
    const language = useAtomValue(languageAtom);
    const selected = allLanguageItems.find((l) => l.id === language);

    return (
        <WButton
            color="primary"
            variant="ghost"
            size="bar"
            icon="jp-web-icon"
            ariaLabel="Language"
            action={undefined}
            {...props}
        >
            {props.showTitle && (
                <>
                    {selected?.title} <MaskIcon className="jp-icon-caretdown size-0.875rem" />
                </>
            )}
        </WButton>
    );
}

export function LocaleFullSelector(props: LocaleButtonProps) {
    return (
        <LocaleMenu>
            <LocaleButton showTitle {...props} />
        </LocaleMenu>
    );
}

export function LocaleNavItem() {
    return (
        <LocaleMenu>
            <LocaleButton />
        </LocaleMenu>
    );
}
